import { PayloadAction } from '@reduxjs/toolkit';
import { defaultBBox } from 'common/utils';
import { BBox } from '@turf/helpers';
import { getValidFitBounds } from '../utils';

import { IState } from '../types/state';

const setStationsFitBounds = (state: IState, action: PayloadAction<BBox>) => {
  const fitBounds = action.payload.length ? action.payload : defaultBBox;
  state.stations.fitBounds = getValidFitBounds(fitBounds);
};

export default setStationsFitBounds;
